import React, {useEffect, useState} from "react";
import {InfiosTextArea, InfiosTextAreaWrapper} from "./TextArea.style";
import {InfiosContainedLabel} from "../Label/ContainedLabel.style";

const TextArea = (props) => {
    const { labelText, disabled, name, id, errorMessage, required, invalid, errorHandler, placeholder, className, limit, validate, value, helpMessage,  inputRef } = props;

    const [error, setError] = useState(false);
    const [valueText, setValueText] = useState("");
    const [charLimit, setCharLimit] = useState(450);

    useEffect(() => {
        setError(invalid);
        setValueText(value);
        if(limit) setCharLimit(limit);
    }, []);

    useEffect(() => {
        setValueText(value);
    }, [value]);

    const handleChange = (event) => {
        const valueEvent = event.target.value;
        if (valueEvent.length <= charLimit) {
            setValueText(valueEvent);
        }
        if(validate){
            validate(valueEvent);
        }
        setError(errorHandler);
    };

    return (
        <InfiosTextAreaWrapper charLimit={charLimit} helpMessage={helpMessage}>
            <InfiosTextArea
                className={`${error ? 'error' : ''} p-regular ${className ? className : ''}`}
                name={name}
                id={id}
                onChange={event => handleChange(event)}
                placeholder={placeholder}
                disabled={disabled}
                value={valueText}
                required={required}
                ref={inputRef}
            />
            {labelText && <InfiosContainedLabel
                className={`label-medium ${valueText ? 'hasValue' : ''}`}
                htmlFor={name}
                required={required}
                disabled={disabled}>
                {labelText}{required ? ' *' : ''}
            </InfiosContainedLabel>}
            {errorMessage && <span className="label-small">{errorMessage || "Error"}</span>}
        </InfiosTextAreaWrapper>
    )
}

export default TextArea;
